module.exports = __webpack_public_path__ + "static/techdaily-81630568a671562c64b9666b797f2b50.png";